import apiClient from '@/axios';


export default {
    async getSummary() {
      const response = await apiClient.get('/accounting/summary');
      return response.data;
    },

    async getTransactions(filters = {}) {
      const response = await apiClient.get('/accounting/orders', { params: filters });
      return response.data.orders;
    },

    async exportOrders(filters = {}) {
      const response = await apiClient.get('/accounting/export-orders', {
        params: filters,
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      const filename = 'orders.xlsx';
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
  };






